define('SageDotCom/Components/ProductCardStoreSelection',["jquery", "SageDotCom/Utility/sageMatchHeight"],
    function ($, SageMatchHeight) {

        function ProductCardStoreSelection(scope, storeBranches, productType, signUpUrl, branchPlaceholder, getOfferButtonDatasource, storeListDatasource, branchListDatasource) {
            //disable first option - placeholder in the store list
            $("." + branchListDatasource + " option").first().prop('disabled', true);
            
            $("." + storeListDatasource).change(function () {
                var chosenStore = this.value;
                var branchesForChosenStore = storeBranches[chosenStore];
                var htmlBranchList = "";
                htmlBranchList += "<option selected disabled>" + branchPlaceholder + "</option>";
                for (var i = 0; i < Object.keys(branchesForChosenStore).length; i++) {
                    var branchName = Object.keys(branchesForChosenStore)[i];
                    var branchCodes = Object.keys(branchesForChosenStore).map(function (e) {
                        return branchesForChosenStore[e];
                    });
                    htmlBranchList += "<option value=" + branchCodes[i] + ">" + branchName + "</option>";
                }

                $("." + branchListDatasource).html(htmlBranchList);
                $("#" + getOfferButtonDatasource).prop("disabled", true);
            });
            
            $("." + branchListDatasource).change(function () {
                $("#" + getOfferButtonDatasource).removeAttr("disabled");
            });
            
            $("#" + getOfferButtonDatasource).click(function () {
                var branchCode = $('.' + branchListDatasource).val();
                signUpUrl = signUpUrl.replace("{0}", productType);
                signUpUrl = signUpUrl.replace("{1}", branchCode);

                window.location.href = signUpUrl;
            });

            new Promise(function (resolve, reject) {
                SageMatchHeight.prototype.applyBinding($(".sage-product-card .product-card-store-selection-content .subheader"), false, { byRow: true });
                resolve();
            });
        }

        ProductCardStoreSelection.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ProductCardStoreSelection(args.scope,
                    args.StoreBranches,
                    args.ProductType,
                    args.SignUpUrl,
                    args.BranchPlaceholder,
                    args.GetOfferButtonDatasource,
                    args.StoreListDatasource,
                    args.BranchListDatasource);
        };

        return ProductCardStoreSelection;
    });
